// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3PHBs","title":"BackImages_title__3trmM","images":"BackImages_images__1SKUi"};